import { render, staticRenderFns } from "./CheckoutDialog.vue?vue&type=template&id=965fa38c&scoped=true"
import script from "./CheckoutDialog.vue?vue&type=script&lang=js"
export * from "./CheckoutDialog.vue?vue&type=script&lang=js"
import style0 from "./CheckoutDialog.vue?vue&type=style&index=0&id=965fa38c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965fa38c",
  null
  
)

export default component.exports